export enum AIPricingEnum {
    'BOWPOD' = 'bow pod',
    'IPUPOD' = 'ipu pod',
    'VIRTUALPOD' = 'virtual pod',
    'NEWPORT' = 'newport',
    'AMSTERDAM2' = 'amsterdam-2',
    'LUXEMBOURG2' = 'luxembourg-2',
    'Manassas' = 'manassas',
}
